import { cx } from "@shared/components/untitledui/util/cx"

type ThreeDotSpinnerProps = {
  white?: boolean
  className?: string
}

export const ThreeDotSpinner = ({ white = false, className }: ThreeDotSpinnerProps) => (
  <div className={cx("three-dot-spinner", white && "-white", className)}>
    <div className="bounce1" />
    <div className="bounce2" />
    <div className="bounce3" />
  </div>
)
